import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatExpansionModule } from '@angular/material/expansion';
import { ReportFieldDefinitionsService, FieldDefinition } from '../../../services/report-field-definitions.service';

@Component({
  selector: 'app-report-glossary',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatExpansionModule
  ],
  templateUrl: './report-glossary.component.html',
  styleUrls: ['./report-glossary.component.scss']
})
export class ReportGlossaryComponent implements OnInit {
  sections: string[] = [];
  definitionsBySection: Map<string, FieldDefinition[]> = new Map();
  searchTerm: string = '';
  filteredDefinitionsBySection: Map<string, FieldDefinition[]> = new Map();

  constructor(
    private dialogRef: MatDialogRef<ReportGlossaryComponent>,
    private fieldDefinitionsService: ReportFieldDefinitionsService
  ) {}

  ngOnInit(): void {
    this.sections = this.fieldDefinitionsService.getSections();
    this.sections.forEach(section => {
      const definitions = this.fieldDefinitionsService.getDefinitionsBySection(section);
      this.definitionsBySection.set(section, definitions);
      this.filteredDefinitionsBySection.set(section, definitions);
    });
  }

  onSearchChange(): void {
    const term = this.searchTerm.toLowerCase().trim();

    if (!term) {
      this.sections.forEach(section => {
        this.filteredDefinitionsBySection.set(
          section,
          this.definitionsBySection.get(section) || []
        );
      });
      return;
    }

    this.sections.forEach(section => {
      const definitions = this.definitionsBySection.get(section) || [];
      const filtered = definitions.filter(def =>
        def.label.toLowerCase().includes(term) ||
        def.description.toLowerCase().includes(term)
      );
      this.filteredDefinitionsBySection.set(section, filtered);
    });
  }

  hasResults(section: string): boolean {
    const filtered = this.filteredDefinitionsBySection.get(section);
    return !!filtered && filtered.length > 0;
  }

  getTotalResults(): number {
    let total = 0;
    this.filteredDefinitionsBySection.forEach(definitions => {
      total += definitions.length;
    });
    return total;
  }

  close(): void {
    this.dialogRef.close();
  }
}
